import React, { useState } from "react";
import logo from "../../Assets/images/q-nexus.png";
import loginArt from "../../Assets/images/login-bg.png";
import { loadingFalse, loadingTrue } from "../../Reducer/loaderSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Handler from "../../Helpers/Handler";
import { Link } from "react-router-dom";
import { reloadWindowToPath, setCookie } from "../../Helpers/Utils";
import { setProfile } from "../../Reducer/customerSlice";
import { useAuth } from "../../Context/AuthenticateProvider";

const Login = () => {
  const [fun, setF] = useState({ email: "", password: "" });
  const [show, setShow] = useState(false);
  const d = useDispatch();
  const { isAuthenticated, setIsAuthenticated } = useAuth()

  const submit = async () => {
    d(loadingTrue());
    const r = await Handler({ method: "post", url: "/auth/login.php", data: fun });
    console.log(r?.data)
    if (r?.success) {
      if (r?.data?.user?.status === 'ACTIVE') {
        setCookie("token", r?.data?.token);
        toast.success("Login Successfull");
        d(loadingFalse());
        if (r?.data?.user?.role === 'business' && !r?.data?.profile_completed) {
          reloadWindowToPath('/user/reg')
        } else if (r?.data?.user?.role === 'business' && r?.data?.profile_completed) {
          reloadWindowToPath('/user/feed')
        } else {
          reloadWindowToPath('/admin/dashboard')
        }
        d(setProfile(r?.data));
        setIsAuthenticated(true)
      }
    }
    else toast.error(r?.message || "Login failed");
    d(loadingFalse());
  };

  return (
    <div className="login-page">
      <div className="login-header  d-none d-md-flex">
        <img src={logo} alt="Qnexus" className="login-logo" />
      </div>
      <div className="login-center">
        <div className="login-card card">
          <img src={logo} alt="Qnexus" className="login-logo d-block d-md-none" />
          <h2 className="login-title text-center">Login</h2>
          <h2 className="login-description text-center">Welcome to Qnexus</h2>
          <div className="form-group mb-3">
            <label>Email address *</label>
            <input type="email" className="form-control" placeholder="Enter email" value={fun?.email} onChange={e => setF({ ...fun, email: e.target.value })} />
          </div>
          <div className="form-group mb-2">
            <label>Enter Password *</label>
            <div className="input-group">
              <input type={show ? "text" : "password"} className="form-control" placeholder="Enter password" value={fun.password} onChange={e => setF({ ...fun, password: e.target.value })} />
              <button type="button" className="btn" onClick={() => setShow(!show)}>
                <i className={`fa ${show ? "fa-eye-slash" : "fa-eye"}`}></i>
              </button>
            </div>
          </div>
          {/* <div className="text-start mb-4">
            <span className="forgot-link cursor-pointer">Forgot Password?</span>
          </div> */}
          <button className="btn login-btn w-100 mt-4" onClick={submit}>Login</button>
          { <div className="text-center mb-4  mt-4">
            <span className="forgot-link cursor-pointer">Don't have an account ? <Link to={'/signup'}>Create</Link></span>
          </div> }
        </div>
      </div>
      <div className="login-art-wrap d-none d-lg-block">
        <img src={loginArt} alt="illustration" />
      </div>

    </div>
  )
}
export default Login;
